import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Title from '../../../components/Telephone/Title';
import TariffItem from './TariffItem';

const TariffBlock = styled.section`
  width: 100%;
  padding-top: 167px;
  padding-bottom: 173px;
  display: block;
  background: #fff;
  text-align: center;

  @media only screen and (max-width: 1919px) {
    padding-top: 72px;
    padding-bottom: 88px;
  }

  @media only screen and (max-width: 1365px) {
    padding-top: 80px;
    padding-bottom: 100px;
  }

  @media only screen and (max-width: 1023px) {
    padding-top: 84px;
    padding-bottom: 90px;
  }
  
  @media only screen and (max-width: 767px) {
    padding-top: 49px;
    padding-bottom: 77px;
  }
`;

const TariffCards = styled.div`
  width: 100%;
  margin-top: 56px;
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
  padding-left: 212px;
  padding-right: 212px;

  @media only screen and (max-width: 1919px) {
    margin-top: 51px;
    padding-left: 106px;
    padding-right: 106px;
  }

  @media only screen and (max-width: 1365px) {
    margin-top: 39px;
    padding-left: 48px;
    padding-right: 48px;
  }

  @media only screen and (max-width: 1023px) {
    margin-top: 46px;
    padding-left: 34px;
    padding-right: 34px;
  }

  @media only screen and (max-width: 767px) {
    margin-top: 32px;
    padding-left: 16px;
    padding-right: 16px;
  }
`;

export default class Tariffs extends Component {
  static propTypes = {
    title: PropTypes.string,
    tariffData: PropTypes.object,
  };

  static defaultProps = {
    title: '',
    tariffData: {},
  }

  render() {
    const { title, tariffData, className } = this.props;

    const favorite_region = tariffData.price_favorite_region ? `${tariffData.price_favorite_region} руб/мес`  : '0 руб/мес';
    const favorite_country = tariffData.price_favorite_country ? `${tariffData.price_favorite_country} руб/мес` : '0 руб/мес';
    const my_moscow = tariffData.price_my_moscow ? `${tariffData.price_my_moscow} руб/мес` : '0 руб/мес';
    let have_60_min = tariffData.have_60_min ? tariffData.have_60_min : 0;

    if (have_60_min === 1) {
      have_60_min = '100 руб/мес';
    } else {
      have_60_min = '0 руб';
    }

    return (
      <TariffBlock className={className}>
        <Title as='h2' title={title} />
        <TariffCards>
          <TariffItem
            icon='/static/images/telephone/map.svg'
            title='Любимый регион'
            desc='Звонки в любимый регион со скидкой'
            price={favorite_region}
          />
          <TariffItem
            icon='/static/images/telephone/planet.svg'
            title='Любимая страна'
            desc='Звонки в другую страну со скидкой'
            price={favorite_country}
          />
          <TariffItem
            icon='/static/images/telephone/60.svg'
            title='60 минут по России'
            desc='Звонки на сотовые и городские со скидкой'
            price={have_60_min}
          />
          <TariffItem
            icon='/static/images/telephone/star.svg'
            title='Моя Москва'
            desc='Звонки в Москву со скидкой'
            price={my_moscow}
          />
        </TariffCards>
      </TariffBlock>
    );
  }
}
